<template>
  <div>
    <div class="rating__wrapper">
      <div class="rating__icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 30 30"
          :width="width"
        >
        
          <g v-if="icon === 'g'" >
            <path class="fill__green" d="M30,27.5A2.5,2.5,0,0,1,27.5,30H2.5A2.51,2.51,0,0,1,0,27.5V2.5A2.5,2.5,0,0,1,2.5,0h25A2.51,2.51,0,0,1,30,2.5Z"/>
            <path class="fill__white" d="M17.65,20.35A3.54,3.54,0,0,1,15,21.43a3.56,3.56,0,0,1-2.58-1c-1-1-.93-2.17-.93-3.82s0-2.84.93-3.81a3.48,3.48,0,0,1,2.58-1,3.42,3.42,0,0,1,3.6,3H16.68A1.64,1.64,0,0,0,15,13.36a1.56,1.56,0,0,0-1.2.51c-.36.4-.45.85-.45,2.69s.09,2.29.45,2.69a1.53,1.53,0,0,0,1.2.5,1.79,1.79,0,0,0,1.33-.53,1.88,1.88,0,0,0,.43-1.28v-.35H15V16h3.61v1.4A3.8,3.8,0,0,1,17.65,20.35Z"/>
            <path class="fill__white" d="M14.73,5.78,4.62,22.89H25.38L15,5.33Zm.27.77,9.3,15.73H5.7C6.21,21.43,14.51,7.38,15,6.55Z"/>
          </g>

          <g v-if="icon === 'pg'" >
            <path class="fill__yellow" d="M30,27.5A2.51,2.51,0,0,1,27.5,30H2.5A2.5,2.5,0,0,1,0,27.5V2.5A2.51,2.51,0,0,1,2.5,0h25A2.5,2.5,0,0,1,30,2.5Z"/>
            <path class="fill__black" d="M10.8,16.45H8.67v4.14H6.53v-11H10.8a3.44,3.44,0,1,1,0,6.87Zm-.11-5h-2v3h2a1.46,1.46,0,0,0,1.6-1.5A1.48,1.48,0,0,0,10.69,11.48Z"/>
            <path class="fill__black" d="M22.42,19.43a4.08,4.08,0,0,1-3.11,1.25,4,4,0,0,1-3-1.2c-1.11-1.12-1.08-2.49-1.08-4.4s0-3.28,1.08-4.39a4,4,0,0,1,3-1.21A4,4,0,0,1,23.46,13H21.29a1.86,1.86,0,0,0-2-1.61,1.75,1.75,0,0,0-1.37.59c-.42.47-.53,1-.53,3.09s.11,2.65.53,3.11a1.75,1.75,0,0,0,1.37.58,2.06,2.06,0,0,0,1.54-.62,2.12,2.12,0,0,0,.48-1.47v-.42h-2v-1.8h4.16v1.61A4.35,4.35,0,0,1,22.42,19.43Z"/>
            <path class="fill__black" d="M26,6.67H3.68V23.32H26.32V6.67Zm-.36.71V22.6H4.39V7.39Z"/>
          </g>

          <g v-if="icon === 'm'" >
            <path class="fill__blue" d="M30,27.5A2.51,2.51,0,0,1,27.5,30H2.5A2.51,2.51,0,0,1,0,27.5V2.5A2.51,2.51,0,0,1,2.5,0h25A2.5,2.5,0,0,1,30,2.5Z"/>
            <path class="fill__white" d="M17.69,20.3V14.21l-2,4H14.32l-2-4v6.1h-2V9.87h2L15,15.51l2.72-5.64h2V20.3Z"/>
            <path class="fill__white" d="M6.38,15A8.62,8.62,0,1,0,15,6.38,8.62,8.62,0,0,0,6.38,15Zm.67,0a8,8,0,1,1,8,8h0A8,8,0,0,1,7.05,15Z"/>
          </g>

          <g v-if="icon === 'm15' || icon === 'ma15' || icon === 'ma15+'" >
            <path class="fill__red" d="M30,23V2.5A2.5,2.5,0,0,0,27.5,0H2.5A2.5,2.5,0,0,0,0,2.49V23Z"/>
            <path d="M0,23v4.38A2.57,2.57,0,0,0,2.49,30h25A2.56,2.56,0,0,0,30,27.38V23Z"/>
            <path class="fill__white" d="M21,13.9V9.54l-.92.81V9.78L21,9h.5V13.9Z"/>
            <path class="fill__white" d="M24.6,13.58a1.29,1.29,0,0,1-1,.37,1.39,1.39,0,0,1-1-.35,1.36,1.36,0,0,1-.34-.86h.49a.78.78,0,0,0,.84.77.85.85,0,0,0,.6-.24,1.32,1.32,0,0,0,.27-1c0-.6-.11-1.2-.82-1.2a.8.8,0,0,0-.82.49H22.4V9h2.49v.44h-2V11a1.12,1.12,0,0,1,.88-.34,1.19,1.19,0,0,1,.85.31A1.76,1.76,0,0,1,25,12.28,1.74,1.74,0,0,1,24.6,13.58Z"/>
            <path class="fill__white" d="M27.3,12.29V13.5h-.47V12.29H25.62v-.47h1.21V10.63h.47v1.2h1.21v.47Z"/>
            <path class="fill__white" d="M9.27,14.93V11.16L8,13.61H7.18L5.94,11.16v3.77H4.67V8.46H5.92L7.61,12l1.68-3.5h1.25v6.47Z"/>
            <path class="fill__white" d="M15.3,14.93l-.38-1.14h-2.3l-.39,1.14H10.91l2.35-6.47h1l2.37,6.47Zm-1.5-4.56L13,12.71h1.61Z"/>
            <path class="fill__white" d="M15.11,5H5.77L1.6,11.64l4.17,6.69h9.46l4.16-6.69L15.23,5ZM15,5.37l3.9,6.27L15,17.92H6c-.11-.19-3.77-6.07-3.9-6.28L6,5.37Z"/>
            <path class="fill__white" d="M4.21,28l-.72-1.44H2.83V28H2.32V24.58H3.64a1,1,0,0,1,1.06.9v.1a.9.9,0,0,1-.68.91L4.81,28Zm-.61-3H2.83v1.08H3.6a.54.54,0,0,0,.1-1.08Z"/>
            <path class="fill__white" d="M5.35,28V24.58H7.54v.47H5.87v1H7.28v.47H5.87v1H7.54V28Z"/>
            <path class="fill__white" d="M9,28a1.56,1.56,0,0,1-1.21-.45l.35-.35a1.14,1.14,0,0,0,.88.33c.44,0,.7-.19.7-.52a.43.43,0,0,0-.14-.36.55.55,0,0,0-.37-.14l-.4-.06a1.19,1.19,0,0,1-.65-.28.87.87,0,0,1-.25-.65,1,1,0,0,1,1.15-1,1.44,1.44,0,0,1,1.06.39l-.33.33A1,1,0,0,0,9.07,25c-.4,0-.62.23-.62.53a.39.39,0,0,0,.13.32A.86.86,0,0,0,9,26l.39.05a1.14,1.14,0,0,1,.64.26.92.92,0,0,1,.28.7C10.27,27.66,9.75,28,9,28Z"/>
            <path class="fill__white" d="M12,25.05v3h-.52v-3h-.93v-.47H13v.47Z"/>
            <path class="fill__white" d="M15.31,28l-.72-1.44h-.65V28h-.52V24.58h1.32a1,1,0,0,1,1.06.9.34.34,0,0,1,0,.1.91.91,0,0,1-.69.91L15.91,28Zm-.61-3h-.76v1.08h.76a.55.55,0,0,0,.59-.49.54.54,0,0,0-.48-.59Z"/>
            <path class="fill__white" d="M16.45,28V24.58H17V28Z"/>
            <path class="fill__white" d="M18.85,28a1.25,1.25,0,0,1-.9-.37c-.34-.33-.34-.71-.34-1.37s0-1,.34-1.38a1.2,1.2,0,0,1,.9-.36,1.17,1.17,0,0,1,1.22,1.05h-.53a.7.7,0,0,0-.81-.58.67.67,0,0,0-.39.2c-.17.18-.21.38-.21,1.07s0,.88.21,1.07a.69.69,0,0,0,.51.2.7.7,0,0,0,.7-.58h.52A1.17,1.17,0,0,1,18.85,28Z"/>
            <path class="fill__white" d="M21.7,25.05v3h-.52v-3h-.93v-.47h2.4v.47Z"/>
            <path class="fill__white" d="M23.12,28V24.58h2.2v.47H23.65v1h1.42v.47H23.65v1h1.67V28Z"/>
            <path class="fill__white" d="M28,27.69a1.25,1.25,0,0,1-.88.32H25.89V24.58H27.1a1.26,1.26,0,0,1,.88.33,1.77,1.77,0,0,1,.35,1.36A1.86,1.86,0,0,1,28,27.69Zm-.36-2.41a.73.73,0,0,0-.58-.23h-.63v2.49H27a.73.73,0,0,0,.58-.24,1.6,1.6,0,0,0,.19-1,1.56,1.56,0,0,0-.18-1Z"/>
          </g>

          <g v-if="icon === 'r18'" >
            <rect width="30" height="30" rx="2.5" ry="2.5"/>
            <path class="fill__white" d="M4.21,28l-.72-1.44H2.83V28H2.32V24.58H3.64a1,1,0,0,1,1.06.9v.1a.9.9,0,0,1-.68.91L4.81,28Zm-.61-3H2.83v1.08H3.6a.54.54,0,0,0,.1-1.08Z"/>
            <path class="fill__white" d="M5.35,28V24.58H7.54v.47H5.87v1H7.28v.47H5.87v1H7.54V28Z"/>
            <path class="fill__white" d="M9,28a1.56,1.56,0,0,1-1.21-.45l.35-.35a1.14,1.14,0,0,0,.88.33c.44,0,.7-.19.7-.52a.43.43,0,0,0-.14-.36.55.55,0,0,0-.37-.14l-.4-.06a1.19,1.19,0,0,1-.65-.28.87.87,0,0,1-.25-.65,1,1,0,0,1,1.15-1,1.44,1.44,0,0,1,1.06.39l-.33.33A1,1,0,0,0,9.07,25c-.4,0-.62.23-.62.53a.39.39,0,0,0,.13.32A.86.86,0,0,0,9,26l.39.05a1.14,1.14,0,0,1,.64.26.92.92,0,0,1,.28.7C10.27,27.66,9.75,28,9,28Z"/>
            <path class="fill__white" d="M12,25.05v3h-.52v-3h-.93v-.47H13v.47Z"/>
            <path class="fill__white" d="M15.31,28l-.72-1.44h-.65V28h-.52V24.58h1.32a1,1,0,0,1,1.06.9.34.34,0,0,1,0,.1.91.91,0,0,1-.69.91L15.91,28Zm-.61-3h-.76v1.08h.76a.55.55,0,0,0,.59-.49.54.54,0,0,0-.48-.59Z"/>
            <path class="fill__white" d="M16.45,28V24.58H17V28Z"/>
            <path class="fill__white" d="M18.85,28a1.25,1.25,0,0,1-.9-.37c-.34-.33-.34-.71-.34-1.37s0-1,.34-1.38a1.2,1.2,0,0,1,.9-.36,1.17,1.17,0,0,1,1.22,1.05h-.53a.7.7,0,0,0-.81-.58.67.67,0,0,0-.39.2c-.17.18-.21.38-.21,1.07s0,.88.21,1.07a.69.69,0,0,0,.51.2.7.7,0,0,0,.7-.58h.52A1.17,1.17,0,0,1,18.85,28Z"/>
            <path class="fill__white" d="M21.7,25.05v3h-.52v-3h-.93v-.47h2.4v.47Z"/>
            <path class="fill__white" d="M23.12,28V24.58h2.2v.47H23.65v1h1.42v.47H23.65v1h1.67V28Z"/>
            <path class="fill__white" d="M28,27.69a1.25,1.25,0,0,1-.88.32H25.89V24.58H27.1a1.26,1.26,0,0,1,.88.33,1.77,1.77,0,0,1,.35,1.36A1.86,1.86,0,0,1,28,27.69Zm-.36-2.41a.73.73,0,0,0-.58-.23h-.63v2.49H27a.73.73,0,0,0,.58-.24,1.6,1.6,0,0,0,.19-1,1.56,1.56,0,0,0-.18-1Z"/>
            <rect class="fill__white" y="23" width="30" height="0.35"/>
            <path class="fill__white" d="M19.41,15.15V10l-1.09,1v-.68l1.09-.94H20v5.82Z"/>
            <path class="fill__white" d="M22.55,15.19a1.62,1.62,0,0,1-1.71-1.56s0-.05,0-.08a1.61,1.61,0,0,1,.88-1.4A1.4,1.4,0,0,1,21,10.86a1.6,1.6,0,1,1,3.2,0,1.42,1.42,0,0,1-.76,1.29,1.58,1.58,0,0,1,.87,1.4,1.64,1.64,0,0,1-1.64,1.65Zm0-2.79a1.14,1.14,0,1,0,0,2.27,1.14,1.14,0,0,0,1.14-1.13h0a1.12,1.12,0,0,0-1.09-1.14Zm0-2.59a1,1,0,0,0-1,1v.07a1,1,0,1,0,2,0,1,1,0,0,0-.93-1Z"/>
            <path class="fill__white" d="M27.09,13.23v1.44h-.55V13.23H25.1v-.54h1.44V11.26h.55v1.42h1.42v.55Z"/>
            <path class="fill__white" d="M11,16.59,9.49,13.44H8.38v3.15H6.83V8.69h3.1a2.38,2.38,0,0,1,2.56,2.41,2.13,2.13,0,0,1-1.44,2.08l1.76,3.4Zm-1.2-6.52H8.38v2.08H9.83a1,1,0,1,0,0-2.08Z"/>
            <path class="fill__white" d="M9.5,4.58l-8,8,8.18,8.17,8.18-8.17L9.68,4.4Zm.18.55,7.45,7.45L9.68,20,2.23,12.58Z"/>
          </g>

          <g v-if="icon === 'ctc'" >
            <path class="fill__orange" d="M30,27.5A2.51,2.51,0,0,1,27.5,30H2.5A2.51,2.51,0,0,1,0,27.5V2.5A2.51,2.51,0,0,1,2.5,0h25A2.5,2.5,0,0,1,30,2.5Z"/>
            <path d="M9.65,12.72a4.73,4.73,0,0,0,0-.84,1.3,1.3,0,0,0-.26-.63.6.6,0,0,0-.25-.2,1.83,1.83,0,0,0-.32-.14,1.73,1.73,0,0,0-.31-.07,2,2,0,0,0-.94.08,1.87,1.87,0,0,0-.47.23,1.34,1.34,0,0,0-.27.26.52.52,0,0,0-.11.19l-.06.13a1.12,1.12,0,0,0-.1.31,6.17,6.17,0,0,0-.1.62c0,.34,0,.69,0,1v2.72a6.78,6.78,0,0,0,.14,1.49,2.23,2.23,0,0,0,.39.84,1.12,1.12,0,0,0,.58.37,2.83,2.83,0,0,0,.71.1,2.7,2.7,0,0,0,.41-.06,1.27,1.27,0,0,0,.53-.27,1.87,1.87,0,0,0,.47-.64,2.92,2.92,0,0,0,.2-1.17h1.33A4.7,4.7,0,0,1,11,18.43a2.82,2.82,0,0,1-.43.91,1.83,1.83,0,0,1-.59.55,2.9,2.9,0,0,1-.65.28,3.16,3.16,0,0,1-.6.11H8.28a7.17,7.17,0,0,1-1-.08,2.15,2.15,0,0,1-1-.47,2.69,2.69,0,0,1-.81-1.18,6.38,6.38,0,0,1-.32-2.29V13.39a5.66,5.66,0,0,1,.23-1.78A2.81,2.81,0,0,1,6,10.48a2.35,2.35,0,0,1,1-.6,4.76,4.76,0,0,1,1.35-.17,2.63,2.63,0,0,1,2.14.76A3.17,3.17,0,0,1,11,12.72Z"/>
            <path d="M18.28,9.92V11H15.6v9H14.3v-9H11.63V9.92Z"/>
            <path d="M23.45,12.72a5.91,5.91,0,0,0,0-.84,1.3,1.3,0,0,0-.26-.63.55.55,0,0,0-.25-.2,1.83,1.83,0,0,0-.32-.14,1.18,1.18,0,0,0-.31-.08,2,2,0,0,0-.94.08,2.28,2.28,0,0,0-.47.23,1.34,1.34,0,0,0-.27.26.52.52,0,0,0-.11.19l-.06.13a1.12,1.12,0,0,0-.1.31q-.06.32-.09.63c0,.34-.05.69-.05,1v2.72a6.23,6.23,0,0,0,.15,1.49,2.06,2.06,0,0,0,.38.84,1.12,1.12,0,0,0,.58.37,2.74,2.74,0,0,0,.7.09,2.7,2.7,0,0,0,.41-.06,1.27,1.27,0,0,0,.53-.27,1.54,1.54,0,0,0,.47-.63,2.75,2.75,0,0,0,.2-1.17h1.34a5.13,5.13,0,0,1-.15,1.35,3,3,0,0,1-.42.91,2,2,0,0,1-.6.55,2.9,2.9,0,0,1-.65.28,2.51,2.51,0,0,1-.6.1l-.45,0a7.28,7.28,0,0,1-1-.08,2.15,2.15,0,0,1-1-.47,2.76,2.76,0,0,1-.81-1.2,6.58,6.58,0,0,1-.32-2.29V13.39a6,6,0,0,1,.23-1.78,2.81,2.81,0,0,1,.66-1.13,2.4,2.4,0,0,1,1-.6,4.76,4.76,0,0,1,1.35-.17,2.63,2.63,0,0,1,2.14.76,3.22,3.22,0,0,1,.53,2.25Z"/>
          </g>

          <g v-if="icon === 'e'" >
            <path class="fill__grey" d="M30,27.5A2.51,2.51,0,0,1,27.5,30H2.5A2.51,2.51,0,0,1,0,27.5V2.5A2.51,2.51,0,0,1,2.5,0h25A2.5,2.5,0,0,1,30,2.5Z"/>
            <path class="fill__white" d="M9.16,7.13V22.87H20.84V7.13Zm11,15.06H9.84V7.81H20.16Z"/>
            <polygon class="b" points="18.45 11.54 18.45 9.8 11.54 9.8 11.54 10.4 11.54 11.54 11.54 18.33 11.54 19.26 11.54 20.18 18.45 20.18 18.45 18.33 13.58 18.33 13.58 15.85 17.78 15.85 17.78 14.04 13.58 14.04 13.58 11.54 18.45 11.54"/>
          </g>
        </svg>

      </div>
    </div>
  </div>

</template>


<script>
export default {
  name: 'movie-ratings',
  props: {
    icon: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: false,
      default () {
        return 30
      },
    },
  },
  components: {},
  data () {
    return {}
  },
  computed: {},
  methods: {},

}
</script>


<style scoped lang="sass">
@import index


.fill
  &__white
    fill: #fff
  &__green
    fill: #0db14b
  &__yellow
    fill: #fff100
  &__black
    fill: #231f20
  &__blue
    fill: #00adee
  &__red
    fill: #ed1c24
  &__orange
    fill: #f7941d
  &__grey
    fill: #818286


</style>



// WEBPACK FOOTER //
// src/components/movie-ratings/movie-ratings.vue